import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const state = {
    user: {},
    music: [],
    recordedData:null,
    selecteduser:{},
    processing:false,
    homeMusic:{},
    currentSlideHome:0,
    pageHome:0,
    swiper:null, 
    isStartAutoplay: false  
}

const mutations = {
    'SET_SWIPER': (state, payload) => {
        state.swiper = payload
    },
    'SET_HOME_MUSIC': (state, payload) => {
        state.homeMusic = payload
    },
    'SET_cURRENT_SLIDE': (state, payload) => {
        state.currentSlideHome = payload
    },
    'SET_PAGE_HOME': (state, payload) => {
        state.pageHome = payload
    },
   
    'SET_USER': (state, payload) => {
        state.user = payload
    },

    'SET_PROCESSING': (state, payload) => {
        state.processing = payload
    },

    'SET_SELECTED_USER': (state, payload) => {
        state.selecteduser = payload
    },

    'SET_MUSIC': (state, payload) => {
        state.music = payload
    },

    'SET_RECORDEDDATA': (state, payload) => {
        state.recordedData = payload
    },
    
    "SET_VIDEO_TIME": (state, payload) => {
        state.isStartAutoplay = payload
    }

}

const actions = {
    setswiper: ({ commit, state }, payload) => {
        commit('SET_SWIPER', payload)
        return state.swiper
    },
    setHomeMusic: ({ commit, state }, payload) => {
        commit('SET_HOME_MUSIC', payload)
        return state.homeMusic
    },

    setCurrentSlideHome: ({ commit, state }, payload) => {
        commit('SET_cURRENT_SLIDE', payload)
        return state.currentSlideHome
    },

    setPageHome: ({ commit, state }, payload) => {
        commit('SET_PAGE_HOME', payload)
        return state.pageHome
    },

    setSelectedUser: ({ commit, state }, payload) => {
        commit('SET_SELECTED_USER', payload)
        return state.selecteduser
    },
    
    setUser: ({ commit, state }, payload) => {
        commit('SET_USER', payload)
        return state.user
    },

    setMusic: ({ commit, state }, payload) => {
        commit('SET_MUSIC', payload)
        return state.music
    },

    setRecordedData: ({ commit, state }, payload) => {
        commit('SET_RECORDEDDATA', payload)
        return state.recordedData
    },

    setProcessing: ({ commit, state }, payload) => {
        commit('SET_PROCESSING', payload)
        return state.processing
    },

    setIsStartAutoplay: ({commit, state}, payload) => {
        commit("SET_VIDEO_TIME", payload)
        return state.isStartAutoplay
    }
}

const getters = {
    homeMusic: (state) => {
        return state.homeMusic
    },
    currentSlideHome: (state) => {
        return state.currentSlideHome
    },
    pageHome: (state) => {
        return state.pageHome
    },
    swiper: (state) => {
        return state.swiper
    }, 
    user: (state) => {
        return state.user
    },

    processing: (state) => {
        return state.processing
    },

    selecteduser: (state) => {
        return state.selecteduser
    },

    music: (state) => {
        return state.music
    },

    recordedData: (state) => {
        return state.recordedData
    },

    isStartAutoplay: (state) => {
        return state.isStartAutoplay
    }
}

const store = new Vuex.Store({
    state,
    mutations,
    actions,
    getters
})

export default store